<template>
    <div id="checkout-history">
        <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
        <div class="vx-breadcrumb mt-1 mb-6">
          <ul class="flex flex-wrap items-center">
              <li class="inline-flex items-end">
                  <router-link to="/after-login">
                      <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
                  </router-link>
                  <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
              </li>
              <li class="inline-flex items-end">
                <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">History</span>
              </li>
          </ul>
        </div>
        <div class="md:flex mb-6" v-if="!config.hide_customer_statistic">
            <vx-card class="font-bold md:mr-3 md:w-1/4 mb-4 md:mb-0">
                <div class="mb-2">
                    Total checkout members
                </div>
                <div class="text-5xl pt-3">
                    {{historySummary.total_checkout}}
                </div>
            </vx-card>
            <vx-card class="font-bold">
                <div>Checked in members</div>
                <div class="flex align-center">
                    <div class="text-5xl pt-6 w-1/6">{{historySummary.today_checkout}}</div>
                    <div class="ml-base h-full w-5/6">
                      <!-- <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 15%" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
                        <div class="progress-bar bg-success" role="progressbar" style="width: 30%" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                        <div class="progress-bar bg-info" role="progressbar" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                      </div> -->
                       <!-- <vs-progress :percent="100" color="primary">
                          <vs-progress :percent="60" color="primary">primary</vs-progress>
                           <vs-progress :percent="40" color="sucess">success</vs-progress>
                       </vs-progress> -->
                        <!-- <transition name="list"> -->
                          <!-- <div class="progress progress-lg m-0" style="width: 500px; height: 1.5rem" v-show="checkoutHistoryData.items.length != 0">
                            <vx-tooltip-custom text="20%" style="width:20%; height: 1.5rem" :active="true" class="progress-tooltip" :custom_active="custom_active">
                              <div class="progress-bar progress-bar-primary" role="progressbar" aria-valuenow="20" aria-valuemin="20" aria-valuemax="100" style="height: 1.5rem">1</div>
                            </vx-tooltip-custom>
                            <vx-tooltip-custom text="30%" style="width:30%; height: 1.5rem" :active="true" class="progress-tooltip" :custom_active="custom_active">
                              <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="30" aria-valuemin="30" aria-valuemax="100" style="height: 1.5rem">2</div>
                            </vx-tooltip-custom>
                            <vx-tooltip-custom text="40%" style="width:40%; height: 1.5rem" :active="true" class="progress-tooltip" :custom_active="custom_active">
                              <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="40" aria-valuemin="40" aria-valuemax="100" style="height: 1.5rem">3</div>
                            </vx-tooltip-custom>
                            <vx-tooltip-custom text="10%" style="width:10%; height: 1.5rem" :active="true" class="progress-tooltip" :custom_active="custom_active">
                              <div class="progress-bar progress-bar-dark" role="progressbar" aria-valuenow="10" aria-valuemin="10" aria-valuemax="100" style="height: 1.5rem">4</div>
                            </vx-tooltip-custom>
                          </div> -->

                        <!-- </transition> -->
                          <progress-bar-custom></progress-bar-custom>
                    </div>
                </div>
            </vx-card>
        </div>
        <div slot="header" class="flex md:flex-row flex-col md:justify-between md:align-center mb-6">
          <div class="sm:flex flex-wrap-reverse items-center flex-grow justify-end">
            <datepicker placeholder="Select Date" class="history-date-filter" v-model="date_filter" clear-button @closed="filterDate" @cleared="filterDate"></datepicker>

            <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown" v-if="checkoutHistoryData._meta.totalCount > 0 && !config.hide_customer_statistic">
              <div class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span
                      class="mr-2"
                    >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ checkoutHistoryData._meta.totalCount - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : checkoutHistoryData._meta.totalCount }} of {{ checkoutHistoryData._meta.totalCount }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu style="width: 100px;">
                      <vs-dropdown-item v-for="(item, i) in options" :key="i" @click="changePage(currentPage = 1, itemsPerPage=item)" v-model="itemsPerPage">
                        <span class="w-full flex justify-between" :class="{'text-primary': itemsPerPage == item}">
                            {{item}}
                            <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="itemsPerPage == item"/>
                        </span>
                      </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown" style="width: 100px">
                  <div
                    class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">{{filter.title}}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu style="width: 120px;">
                    <vs-dropdown-item v-for="(item, i) in filterOptions" :key="i" v-model="filter" @click="filterType(item)">
                      <span class="w-full flex justify-between" :class="{'text-primary': filter.id == item.id}">
                        {{item.title}}
                        <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="filter.id == item.id"/>
                      </span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <div class="con-input-search vs-table--search ml-4">
                  <input type="text" class="input-search vs-table--search-input rounded-item border-custom" @keyup="searchHistory" placeholder="Name, phone">
                  <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                </div>
          </div>
        </div>
        
        <div id="checkout-history-table" class="overflow-hidden">
        <vs-table ref="table" :max-items="itemsPerPage" :data="checkoutHistoryItems" class="vs-con-loading__container" style="width: 100%; overflow: auto !important;">
                <template slot="thead">
                    <vs-th class="w-1/24">No.</vs-th>
                    <vs-th class="w-3/12">User</vs-th>
                    <vs-th class="w-2/12 center-title">Check Out Time</vs-th>
                    <vs-th class="w-3/24">Services</vs-th>
                    <vs-th class="w-1/12 center-title p-0">Point bonus</vs-th>
                    <vs-th class="w-1/12 center-title p-0">Current Points</vs-th>
                    <vs-th class="w-1/12 center-title">Member Type</vs-th>
                    <vs-th class="w-1/12 center-title p-0" v-if="config.check_in && config.check_in.signature_active == 1">Signed consent</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                    <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                        class="item-description"
                        @click.native="openPopupHistory(tr)"
                    >
                        <vs-td class="position-relative">
                          <feather-icon icon="EditIcon" svgClasses="w-6 h-5 stroke-current text-primary" class="note-icon" v-if="tr.customer && tr.customer.note && tr.customer.note != ''" />
                          {{indextr + 1}}
                        </vs-td>
                        <vs-td v-if="tr.customer">
                          <div>
                              <h4 class="item-name font-bold leading-loose p-0">{{tr.customer.full_name}}</h4>
                              <span class="flex text-sm">
                                <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1" />
                                <span class="font-bold">{{StringHelper.phoneNumberFormat(tr.customer.phone, true)}}</span>
                              </span>
                          </div>
                        </vs-td>

                        <vs-td>
                          <div class="text-center" v-if="tr.update_at">
                            <div class="text-center">{{changeFormatDay(tr.update_at)}}</div>
                            <div class="text-center">{{changeFormatTime(tr.update_at)}}</div>
                          </div>
                          <div class="text-center" v-else>
                            <!-- <div>{{changeFormatDay(tr.created_at)}}</div>
                            <div>{{changeFormatTime(tr.created_at)}}</div> -->
                            N/A
                          </div>
                        </vs-td>

                        <vs-td>
                          <!-- <feather-icon icon="GridIcon" svgClasses="h-10 w-10 p-2 text-white gradient gradient-primary no-shadow rounded-full material-icons cursor-pointer"
                          @click.stop="openPopupService(tr)"/> -->
                          <div v-if="tr.check_in && tr.check_in.services && tr.check_in.services.length > 0">
                            <span v-for="(service, index) in tr.check_in.services" :key="index" class="pr-2 pb-2 d-inline-block">
                              <span class="px-1 bg-warning rounded text-white d-inline-block break-word text-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 200px;" @click.stop="changeStatusServiceShowFull(indextr, index)" v-if="!service.show_full">{{getAcronym(service.name)}}</span>
                              <span class="px-1 bg-warning rounded text-white d-inline-block break-word text-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 200px;" @click.stop="changeStatusServiceShowFull(indextr, index)" v-else>{{service.name}}</span>
                            </span>
                          </div>
                          <div v-else>N/A</div>
                        </vs-td>

                        <vs-td v-if="tr.customer">
                          <div class="text-center" style="color: green;">+{{tr.point_bonus}}</div>
                        </vs-td>

                        <vs-td v-if="tr.customer">
                        <div class="text-center">{{tr.customer.current_point}} Pts</div>
                        </vs-td>

                        <vs-td v-if="tr.customer">
                            <div>
                                <vs-alert
                                :color="getMemberTypeColor(tr.customer.type)"
                                class="flex align-center justify-center mx-auto"
                                style="width: 70px; height: 35px !important"
                                >{{tr.customer.type}}</vs-alert>
                            </div>
                        </vs-td>
                        <vs-td v-if="config.check_in && config.check_in.signature_active == 1">
                          <feather-icon 
                          v-if="tr.check_in.attachment"
                          icon="CheckCircleIcon" 
                          class="flex align-center justify-center"
                          style="color: #2979FF"
                          @click.stop="openSignaturePopup(tr)"
                          ></feather-icon>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
        </div>
        <div v-if="checkoutHistoryData._meta.pageCount > 1">
          <!-- <vs-pagination class="custom-pagination" :total="parseInt(checkoutHistoryData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
         <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(checkoutHistoryData._meta.pageCount)"
            :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
        </div>
        <signature-popup :popupConfig="popupSignature" :key="signatureKey + 'history'"></signature-popup>
        <checkout-history-popup :popupConfig="popupConfig" @CloseHistoryPopup="popupConfig.isOpen = false" :key="history_detail_key" :currentPage="currentPage" :itemsPerPage="itemsPerPage" @Refresh="changePage(currentPage, itemsPerPage)" :search="search" :filter="filter"></checkout-history-popup>
        <history-service-detail :popupServiceConfig="popupServiceConfig"></history-service-detail>
    </div>
</template>
<script>
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';
    import { StringHelper } from '../models/string_helper';
    import {changeFormatHelper} from '../helper/datetimeHelper';
    export default {
        components: {
          Datepicker
        },
        props: {
          dataChange: {
            type: Object
          }
        },
        data() {
            return {
                history_detail_key: 0,
                StringHelper,
                items: [
                    {
                        title: 'Home',
                        url: '/'
                    },
                    {
                        title: 'History',
                        active: true,
                    },
                ],
                search: '',
                options: [ 10,15,20],
                filterOptions: [
                  {id: 1, title: 'All', name: 'all'},
                  {id: 2, title: 'New', name: 'new'},
                  {id: 3, title: 'At risk', name: 'atrisk'},
                  {id: 4, title: 'Vip', name: 'vip'},
                  {id: 5, title: 'Regular', name: 'regular'},
                  {id: 6, title: 'Normal', name: 'normal'},
                ],
                filter: {id: 1, title: 'All', name: 'all'},
                currentPage: 1,
                itemsPerPage: 10,
                max:100,
                popupConfig: {
                  isOpen: false,
                  item_info: {}
                },
                popupServiceConfig: {
                  isOpen: false,
                  item_info: {}
                },
                custom_active: true,
                isOpenLoading: false,
                page_key: 0,
                popupSignature: {
                    title: "Signature",
                    isOpen: false,
                    attachment: null
                },
                signatureKey: 0,
                date_filter: null
            }
        },
        watch: {
          dataChange: {
            immediate: true,
            deep: true,
            handler: function () {
              // if(this.dataChange) {
              //   console.log(this.dataChange.message);
              // }
              // if(this.dataChange && this.dataChange.message == 'afterInsert') {
              if(this.dataChange) {
                const obj = {
                  page: this.currentPage,
                  "per-page": this.itemsPerPage,
                  "keyword": this.search,
                  type: this.filter.name
                }
                if(this.filter.id == 1) {
                  delete obj.type
                }
                this.$store.dispatch("checkin/GET_CHECKOUT_HISTORY", obj)
              }
            },
          }
        },
        methods: {
          openLoadingInDiv(){
                this.$vs.loading({
                    container: '#checkout-history-table',
                    scale: 0.8
                })
                if (this.loadTime) {
                    clearTimeout(this.loadTime);
                    this.loadTime = null;
                }
                this.isOpenLoading = true;
                this.loadTime = setTimeout(() => {
                    if (this.isOpenLoading) {
                      this.closeLoading();
                      // this.$vs.notify({
                      //     title: "Notification",
                      //     text: "Get list failed",
                      //     color: "danger",
                      //     position: "top-right"
                      // });
                      this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: 'Get list failed',
                        acceptText: 'OK'
                      })
                    }
                }, 10000);
                // setTimeout( ()=> {
                //   this.$vs.loading.close('#staff-list > .con-vs-loading')
                // }, 500);

                },
            closeLoading() {
                this.isOpenLoading = false;
                this.$vs.loading.close('#checkout-history-table > .con-vs-loading');
            },
            getAcronym(name) {
              let arr_word = name.split(' ');
              let str = '';
              for(let i = 0; i < arr_word.length; i++) {
                str += arr_word[i].charAt(0).toUpperCase();
                if(i == 3) {
                  break;
                }
              }
              if(str[str.length - 1] == '$') {
                str = str.substring(0, str.length - 1);
              }
              return str;
            },
            changeStatusServiceShowFull(checkin_index, service_index) {
              // if(this.checkoutHistoryItems[checkin_index] && this.checkoutHistoryItems[checkin_index].check_in && this.checkoutHistoryItems[checkin_index].check_in.services[service_index]) {
              //   this.$store.dispatch('checkin/CHANGE_STATUS_SERVICE_SHOW_FULL', {checkin_index: checkin_index, service_index: service_index});
              // }
              this.checkoutHistoryItems[checkin_index].check_in.services[service_index].show_full = !this.checkoutHistoryItems[checkin_index].check_in.services[service_index].show_full;
            },
            filterType(type) {
              this.filter = type;
              this.currentPage = 1;
              const obj = {
                page: this.currentPage,
                "per-page": this.itemsPerPage,
                "keyword": this.search,
                type: this.filter.name
              }
              if(this.date_filter) {
                obj.date = moment(this.date_filter).format('YYYY-MM-DD')
              }
              if(this.filter.id == 1) {
                delete obj.type
              }
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.$store.dispatch('checkin/GET_CHECKOUT_HISTORY', obj).then(() => {
                this.closeLoading();
              })
            },
            filterDate() {
              this.currentPage = 1;
              const obj = {
                page: this.currentPage,
                "per-page": this.itemsPerPage,
                "keyword": this.search,
                type: this.filter.name,
              }
              if(this.date_filter) {
                obj.date = moment(this.date_filter).format('YYYY-MM-DD')
              }
              if(this.filter.id == 1) {
                delete obj.type
              }
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.$store.dispatch('checkin/GET_CHECKOUT_HISTORY', obj).then(() => {
                this.closeLoading();
              })
            },
            changeFormatDay(day){
              if(day) {
                return changeFormatHelper(day);
              } else {
                return 'N/A';
              }
            },
            changeFormatTime(day){
              if(day) {
                return moment(day).format('hh:mm A');
              } else {
                return '';
              }
            },
            changePage(currentPage) {
              // this.isCheckAll = false;
                const obj = {
                    page: currentPage,
                    "per-page": this.itemsPerPage,
                    "keyword": this.search,
                    // type: this.filter.name
                }
                if(this.date_filter) {
                  obj.date = moment(this.date_filter).format('YYYY-MM-DD')
                }
                if(this.filter.id != 1) {
                  obj.type = this.filter.name;
                }
                if(!this.isOpenLoading) {
                  this.openLoadingInDiv();
                }
                this.$store.dispatch("checkin/GET_CHECKOUT_HISTORY", obj).then((response) => {
                  this.closeLoading();
                  this.page_key++;
                  this.currentPage = currentPage;
                  if(response.items) {
                    let data = response.items;
                    for(let i = 0; i < data.length; i++) {
                      if(data[i].customer_id == this.popupConfig.item_info.customer_id) {
                        this.popupConfig.item_info = data[i];
                        break;
                      }
                    }
                  }
                })
            },
            searchHistory({target}) {
              if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
              }
              // this.$vs.loading({
              //   container: "#app",
              //   scale: 0.8
              // });
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }

              this.timer = setTimeout(() => {
                this.search = target.value;
                this.currentPage = 1;
                const obj = {
                  page: this.currentPage,
                  "per-page": this.itemsPerPage,
                  "keyword": target.value,
                  type: this.filter.name
                };
                if(this.date_filter) {
                  obj.date = moment(this.date_filter).format('YYYY-MM-DD')
                }
                if(this.filter.id == 1) {
                  delete obj.type
                }
                this.$store.dispatch('checkin/GET_CHECKOUT_HISTORY',obj).then(() => {
                  // this.$vs.loading.close("#app > .con-vs-loading");
                  this.closeLoading();
                });
              }, 500);
              // this.openLoadingInDiv();
              // this.search = target.value;
              // this.currentPage = 1;
              // const obj={
              //   page: this.currentPage,
              //   "per-page": this.itemsPerPage,
              //   "keyword": target.value,
              //   type: this.filter.name
              // }
              // if(this.filter.id == 1) {
              //   delete obj.type
              // }
              // this.$store.dispatch('checkin/GET_CHECKOUT_HISTORY',obj).then(() => {
              //   // this.closeLoading();
              // })
            },
            openPopupService(data) {
              this.popupServiceConfig.isOpen = true;
              this.popupServiceConfig.item_info = data;
            },
            getMemberTypeColor(member_type) {
                if (member_type == "new") return "success";
                if (member_type == "regular") return "primary";
                if (member_type == "atrisk") return "warning";
                if (member_type == "vip") return "danger";
                return "purple";
            },
            openPopupHistory(data) {
              this.history_detail_key++;
              this.popupConfig.item_info = data;
              this.popupConfig.isOpen = true;
            },
            openSignaturePopup(data){
              if (data.check_in.attachment != null) {
                this.signatureKey++;
                this.popupSignature.attachment = data.check_in.attachment;
                this.popupSignature.title = data.customer.full_name;
                this.popupSignature.isOpen = true;
              }
            }
        },
        computed: {
            checkoutHistoryData() {
              return this.$store.getters['checkin/checkoutHistory'];
            },
            historySummary() {
              return this.$store.getters['checkin/historySummary'];
            },
            checkoutHistoryItems() {
              console.log(this.$store.getters['checkin/checkoutHistoryItems'])
              return this.$store.getters['checkin/checkoutHistoryItems'];
            },
            config() {
              return this.$store.getters["auth/config"];
            }
        },
        created() {
            this.$store.dispatch('checkin/GET_CHECKOUT_HISTORY', {page: this.currentPage, 'per-page': this.itemsPerPage});
            this.$store.dispatch('checkin/GET_CHECKOUT_HISTORY_SUMMARY');
        }
    }
</script>